import { render, staticRenderFns } from "./basic-picker.mpx?vue&type=template&id=c1e9e6f8&isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex"
import script from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex"
export * from "./basic-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex"
import style0 from "./basic-picker.mpx?vue&type=style&index=0&id=c1e9e6f8&prod&lang=stylus&mpxStyleOptions=%7B%22scoped%22%3Atrue%2C%22mid%22%3A%22_87cc6bdc%22%7D&isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports